import React, { useState } from "react";
import newsPortal1 from "../assets/images/news-port1.svg";
import newsPortal2 from "../assets/images/news-port2.svg";
import newsPortal3 from "../assets/images/news-port3.svg";
import Button from 'react-bootstrap/Button';
import { useAuth } from "../../src/context/AuthContext";



const newsportals = [
  {
    id: 1,
    type: "article", // Regular post
    username: "USD Today",
    handel: "@usdtoday",
    profilePic: newsPortal1, // Replace with actual profile picture URL
    member:"330",
    followers:"15.8 M"
  },
  {
    id: 2,
    type: "article", // Regular post
    username: "Time of Inonesia",
    handel: "@toi",
    profilePic: newsPortal2, // Replace with actual profile picture URL
    member:"230",
    followers:"6.8 M"
  },
  {
    id: 3,
    type: "article", // Regular post
    username: "Reuters",
    handel: "@reuters",
    profilePic: newsPortal3, // Replace with actual profile picture URL
    member:"250",
    followers:"10.1 M"
  },
  {
    id: 4,
    type: "article", // Regular post
    username: "All Book Publications",
    handel: "@ABP",
    profilePic: newsPortal3, // Replace with actual profile picture URL
    member:"280",
    followers:"11.8 M"
  },
  {
    id: 5,
    type: "article", // Regular post
    username: "Reuters",
    handel: "@reuters",
    profilePic: newsPortal3, // Replace with actual profile picture URL
    member:"250",
    followers:"10.1 M"
  },
  {
    id: 6,
    type: "article", // Regular post
    username: "Time of Inonesia",
    handel: "@toi",
    profilePic: newsPortal2, // Replace with actual profile picture URL
    member:"230",
    followers:"6.8 M"
  },
];

const NewsPortal = ({ newsportal }) => {
  const { isAuthenticated } = useAuth();



  return (
    <div className="publication-card">
      <div className="left-section">
        <img src={newsportal.profilePic} alt={newsportal.username} className="publication-logo" />
        <div className="publication-info">
          <h4>{newsportal.username}</h4>
          <p className="handle">{newsportal.handel}</p>
          <p className="stats">
            {newsportal.member} Members • {newsportal.followers} Followers
          </p>
        </div>
      </div>
      {/* Follow Button */}
      {/* <Button variant="outline-primary" className="br-10 follow-btn" disabled={!isAuthenticated}>
          Follow
      </Button> */}
      {isAuthenticated && (
          <Button variant="outline-primary" className="br-10 follow-btn">
              JOIN
          </Button>
      )}
    </div>
  );
};

const NewsPortalList = () => {
  const [visible, setVisible] = useState(4); // Show 4 by default

  const handleViewMore = () => {
    setVisible(visible + 4); // Load more items
  };

  return (
    <div className="newsportal-wrapper">
      {newsportals.slice(0, visible).map((newsportal) => (
        <NewsPortal key={newsportal.id} newsportal={newsportal} />
      ))}

      {visible < newsportals.length && (
        <button className="view-more-btn" onClick={handleViewMore}>
          View More
        </button>
      )}
    </div>
  );
};

export default NewsPortalList;
